var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section grid-view", staticStyle: { padding: "10px 20px" } },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "operations",
            staticStyle: { "margin-bottom": "5px" }
          },
          [
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "new",
                        disabled: !_vm.canCarrierCredit,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showEditDialog(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "Edit",
                        disabled: !_vm.canCarrierCredit,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showEditDialog(false)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "delete",
                        disabled: !_vm.canCarrierCredit,
                        type: "danger"
                      },
                      on: { click: _vm.remove }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "grid-params": _vm.girdParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.girdParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.girdParams = $event
                },
                gridReady: _vm.onGridReady
              }
            })
          ],
          1
        )
      ]),
      _c("cabin-carrier", {
        attrs: {
          "v-if": _vm.cabinCarrierDialog.visible,
          visible: _vm.cabinCarrierDialog.visible,
          "cabin-scheme": _vm.cabinCarrierDialog.cabinScheme,
          status: _vm.cabinCarrierDialog.status
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cabinCarrierDialog, "visible", $event)
          },
          "update:status": function($event) {
            return _vm.$set(_vm.cabinCarrierDialog, "status", $event)
          },
          func: _vm.saveTemporary
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }